import React, { useContext, useRef, useState } from 'react';
import { withAuthorization } from '../../components/Session';
import { GoBackButton } from '../../components/Navigation';
import FreightForwarderForm from './form';
import Spinner from '../../components/Spinner';

import Typography from '@material-ui/core/Typography';
import * as ROLES from '../../constants/roles';
import { compose } from 'recompose';
import Grid from '@material-ui/core/Grid';
import { useHistory } from 'react-router-dom';
import { FreightForwarder, BaseFields, User } from '../../../types';
import { FirebaseContext } from '../../components/Firebase';

const FreightForwarderNewPage: React.ComponentType<any> = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const firebase = useContext(FirebaseContext);
  const currentFreightForwarder = useRef<Omit<FreightForwarder, keyof BaseFields>>({
    name: '',
    address: '',
    phone_number: '',
    suburb: '',
    city: '',
    region: '',
    postCode: '',
    country: '',
    postal_address: '',
    url: '',
    primaryColor: '',
    baseCurrencyCode: 'NZD',
    currencies: [],
    terms_and_conditions: [],
    conditions_of_trade: '',
    defaults: { lengthUnit: 'm', volumeToKgRatio: 167, volumeUnit: 'm3', weightUnit: 'kg', volumeRoundingDp: 2 },
    cyberFreight: { postUrl: '' },
    logo_images: [],
    client_tiers: [],
  }).current;

  const create = (freightForwarder: Partial<FreightForwarder>) => {
    setLoading(true);
    firebase
      .freightForwarderCreate(freightForwarder)
      .then(() => {
        setLoading(false);
        history.push(`/admin/freight-forwarders`);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <Spinner visible={loading} />
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Typography variant="h1">New Freight Forwarder</Typography>
        </Grid>
        <Grid item xs={6}>
          <Grid container justifyContent="flex-end">
            <GoBackButton />
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FreightForwarderForm
            freightForwarder={currentFreightForwarder}
            onSubmit={create}
            submitButtonText="Create Freight Forwarder"
          />
        </Grid>
      </Grid>
    </div>
  );
};

const condition = (authUser: User) => authUser && authUser.roles && authUser.roles.includes(ROLES.ADMIN);

export default compose(withAuthorization(condition))(FreightForwarderNewPage);
